import { Box } from '@mui/material';
import * as React from 'react';
import { UseFormReturn, useFieldArray } from 'react-hook-form';

import { Enum } from '~/data/enums';
import { HourlySalaryComponent } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/SalaryProposalForm/components/HourlySalaryComponents/components/HourlySalaryComponent';
import { SalaryProposalFormData } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/SalaryProposalForm/data';
import { SalaryProposalFieldProps } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposals/components/EmployeeSalaryProposalsLayout/useSalaryProposalsLayout';

import { useSxStyles } from './useStyles';

type PropsType = {
  form: UseFormReturn<SalaryProposalFormData>;
  currency: string;
  hourlySalaryEnums: Enum[];
  disabled?: boolean;
  fieldProps: SalaryProposalFieldProps;
};
export const HourlySalaryComponents = (props: PropsType) => {
  const { form, currency, disabled, fieldProps } = props;
  const { control } = form;
  const sxStyles = useSxStyles();

  const fieldArrayName = 'hourlySalaryComponents';

  const { fields } = useFieldArray({ control, name: fieldArrayName });

  return (
    <Box sx={sxStyles.root}>
      {fields.map((_, index) => {
        return (
          <HourlySalaryComponent
            key={`hourlySalaryComponent${index}`}
            form={form}
            currency={currency}
            index={index}
            disabled={disabled}
            fieldProps={fieldProps}
          />
        );
      })}
    </Box>
  );
};
